export default __webpack_public_path__ + "static/media/search-interface-symbol.d3724df4.svg";